document.getElementById("hamburger").addEventListener("click", function () {
  document.getElementById("hamburger").classList.toggle("open");
  document.getElementById("slide").classList.toggle("show");
});

if (document.getElementById("project") !== null) {
  document.getElementById("sales").addEventListener("click", function () {
    document.getElementById("engineer").classList.remove("current");
    document.getElementById("engineerContent").classList.remove("current");
    document.getElementById("sales").classList.add("current");
    document.getElementById("salesContent").classList.add("current");
  });
  document.getElementById("engineer").addEventListener("click", function () {
    document.getElementById("sales").classList.remove("current");
    document.getElementById("salesContent").classList.remove("current");
    document.getElementById("engineer").classList.add("current");
    document.getElementById("engineerContent").classList.add("current");
  });

  let urlParam = decodeURI(location.search.substring(1));

  if (urlParam) {
    let param = urlParam.split("&");
    let paramArray = [];
    for (i = 0; i < param.length; i++) {
      let paramItem = param[i].split("=");
      paramArray[paramItem[0]] = paramItem[1];
    }

    if (paramArray.project) {
      if (paramArray.project == "engineer") {
        document.getElementById("sales").classList.remove("current");
        document.getElementById("salesContent").classList.remove("current");
        document.getElementById("engineer").classList.add("current");
        document.getElementById("engineerContent").classList.add("current");
      }
    }
  }
}

if (
  document.getElementById("entry") !== null ||
  document.getElementById("contact") !== null ||
  document.getElementById("privacyPolicy") !== null ||
  document.getElementById("confirm") !== null ||
  document.getElementById("404") !== null
) {
  document.getElementById("header").classList.remove("white");
  document.getElementById("linkImg").src = document.getElementById("linkImg").src.replace("link.svg", "link-black.svg");
}

if (document.getElementById("staff") !== null) {
  document.querySelectorAll(".staffItem").forEach((element) => {
    element.addEventListener("click", function () {
      document.getElementById(element.dataset.target).classList.add("show");
    });
  });

  document.querySelectorAll(".modalClose").forEach((element) => {
    element.addEventListener("click", function () {
      element.parentElement.parentElement.classList.remove("show");
    });
  });

  document.querySelectorAll(".modalMask").forEach((element) => {
    element.addEventListener("click", function () {
      element.parentElement.classList.remove("show");
    });
  });

  document.getElementById("staffMoreBtn").addEventListener("click", function () {
    document.querySelectorAll(".staffItem.hide").forEach((element) => {
      element.classList.remove("hide");
      document.getElementById("staffMoreBtn").classList.add("hide");
    });

    document.querySelectorAll(".staffItem.hide-sp").forEach((element) => {
      element.classList.remove("hide-sp");
    });
  });

  document.querySelectorAll(".staff__modal-info").forEach((element) => {
    if (element.scrollHeight < 371) {
      element.style.overflow = "auto";
    }
  });
}

if (document.getElementById("frontPage") !== null) {
  const commitmentTarget = window.innerHeight / 3;
  const commitmentBg = document.getElementById("commitmentBg");

  if (window.scrollY >= commitmentTarget) {
    commitmentBg.classList.add("show");
  } else {
    commitmentBg.classList.remove("show");
  }

  window.addEventListener("scroll", function () {
    if (window.scrollY >= commitmentTarget) {
      commitmentBg.classList.add("show");
    } else {
      commitmentBg.classList.remove("show");
    }
  });
}

if (document.getElementById("confirm") !== null) {
  document.querySelectorAll("p").forEach((element) => {
    if (element.textContent.indexOf("入力ページにて内容を入力してください。") > -1) {
      element.style.marginTop = "30px";
      element.style.color = "#dc3232";
    }
  });
}

if (document.getElementById("loading") !== null) {
  window.addEventListener("load", function () {
    document.getElementById("loading").classList.add("hide");
  });

  setTimeout(function () {
    document.getElementById("loading").classList.add("hide");
  }, 3000);
}

document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".gtranslate_wrapper a");
  items.forEach((item) => {
    const lang = item.getAttribute("data-gt-lang");
    if (lang === "ja") item.textContent = "JP";
    if (lang === "en") item.textContent = "EN";

    if (window.matchMedia("(max-width: 768px)").matches) {
      item.addEventListener("click", () => {
        document.getElementById("hamburger").classList.toggle("open");
        document.getElementById("slide").classList.toggle("show");
      });
    }
  });
});
